import { render, staticRenderFns } from "./DisciplinaryDelete.vue?vue&type=template&id=04164a9f"
import script from "./DisciplinaryDelete.vue?vue&type=script&lang=js"
export * from "./DisciplinaryDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports